import { c as _c } from "react/compiler-runtime";
import { SelectRole } from "@components/role/select-role";
import { FaroCoreApiConst } from "@stellar/core-api-client";

/** Renders a dropdown to select group role */
export function SelectGroupRole(t0) {
  const $ = _c(9);
  const {
    selectedRole,
    onChange,
    variant,
    disabledRoles: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const disabledRoles = t2;
  let t3;
  if ($[2] !== onChange) {
    t3 = function onSelectRoleChange(role) {
      onChange(role);
    };
    $[2] = onChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onSelectRoleChange = t3;
  let t4;
  if ($[4] !== disabledRoles || $[5] !== onSelectRoleChange || $[6] !== selectedRole || $[7] !== variant) {
    t4 = <SelectRole label="Role" roles={FaroCoreApiConst.allGroupRoles} disabledRoles={disabledRoles} variant={variant} selectedRole={selectedRole} onChange={onSelectRoleChange} link="workspaceRolesHelp" dataTestId="group-role-selector" />;
    $[4] = disabledRoles;
    $[5] = onSelectRoleChange;
    $[6] = selectedRole;
    $[7] = variant;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}